import { useLocation } from 'react-router-dom';
import { Navbar } from '../nav/Navbar';
import { RequestDemo } from '../sections/RequestDemo';
import { Footer } from '../sections/Footer';
import styles from './Layout.module.css';

/**
 * Every page gets the demo CTA and footer for free — the comp repeats that pair
 * at the bottom of all seven frames, so pages never import them individually.
 */
export function Layout({ children }) {
  // Keying on pathname restarts the fade on every navigation; without it the
  // animation only runs on first mount.
  const { pathname } = useLocation();

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <Navbar />
      <main id="main" key={pathname} className={styles.main}>
        {children}
      </main>
      <RequestDemo />
      <Footer />
    </>
  );
}
